module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-12-72fc502c4b76578873191f48c902e9bd.jpg";